import { getDetails } from "../../webRatingNew/apiHelpers/frontRating";
import { normalizeLocationId } from "../../Survey/helpers/resolveLocationId";

function readEmployeesFromDetail(detail) {
  if (Array.isArray(detail?.employees)) {
    return detail.employees;
  }
  if (Array.isArray(detail?.employee)) {
    return detail.employee;
  }
  return [];
}

function isCurrentLocation(locationId) {
  return (
    normalizeLocationId(localStorage.getItem("location")) ===
    normalizeLocationId(locationId)
  );
}

/**
 * L&D-only: load location staff into localStorage (same source Normal survey uses).
 * Returns the employees array, or [] when location is missing / fetch fails.
 * Skips writing storage if location changed (or was cleared) while the request was in flight.
 */
export async function loadLearningEmployees(locationId) {
  const requestedId = normalizeLocationId(locationId);
  if (!requestedId) {
    return [];
  }

  try {
    const detail = await getDetails(requestedId, "forEmp");
    const employees = readEmployeesFromDetail(detail);

    if (!isCurrentLocation(requestedId)) {
      return employees;
    }

    localStorage.setItem("employees", JSON.stringify(employees));
    return employees;
  } catch {
    if (isCurrentLocation(requestedId)) {
      localStorage.setItem("employees", JSON.stringify([]));
    }
    return [];
  }
}
